import axios from "axios";

const base = `${process.env.REACT_APP_BACKEND_URL}/notifications`;
const headers = () => ({ headers: { Authorization: "Bearer " + localStorage.getItem("token") } });

export const getSettings = () => axios.get(`${base}/settings`, headers());
export const saveSettings = body => axios.put(`${base}/settings`, body, headers());
export const testSend = body => axios.post(`${base}/test`, body, headers());
export const getLog = params => axios.get(`${base}/log`, { ...headers(), params });
export const getCustomers = params => axios.get(`${base}/customers`, { ...headers(), params });
export const saveConsent = (id, body) =>
  axios.put(`${base}/customers/${id}/consent`, body, headers());
export const sendOnTheWay = (id, body) =>
  axios.post(`${base}/appointments/${id}/on-the-way`, body, headers());
export const getAppointmentMessages = id =>
  axios.get(`${base}/appointments/${id}/messages`, headers());

export const getReviews = params => axios.get(`${base}/reviews`, { ...headers(), params });
export const getReviewMeta = () => axios.get(`${base}/reviews/meta`, headers());
export const saveReviewSettings = body => axios.put(`${base}/reviews/settings`, body, headers());
export const sendReviewRequest = body => axios.post(`${base}/reviews`, body, headers());
